// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"118":"f081a00a","453":"6811f146","454":"594378a4","702":"6bb57a22"}[chunkId] + ".chunk.js");